<template>
	<div>
		<div class="wrapper" ma-0>
			<!-- 서브 헤더 --------- start -->
			<v-layout wrap class="mb-2" align-center>
				<v-icon color="#9D9DB7">
					mdi-circle-small
				</v-icon>
				<span class="sub_header">캠페인 현황관리</span>
			</v-layout>
			<!-- 서브 헤더 ----------- end -->

			<v-layout align-center class="header_search">
				<v-layout class="search_wrap">
					<v-layout>
						<v-flex class="search_select_type ml-4" style="width:300px; max-width:300px;">
							<selectBox :sel="surveySel_project" class="searchSel" @change="search_reservedays()"></selectBox>
						</v-flex>
					</v-layout>

					<!-- 날짜 선택 --------- start -->
					<v-layout justify-end>
						<!-- 이름 검색 start  -->
						<v-flex md4 sm4 xs12>
							<txtField
								class="search_box_type"
								v-model="search.value"
								:txtField="search"
								@keyup.enter="searchKeyword"
								ref="search_input"
							></txtField>
						</v-flex>

						<v-btn class="search_btn" color="#ff9419" @click="searchKeyword"><v-icon>mdi-magnify</v-icon>조회</v-btn>
						<!-- 이름 검색 end  -->
					</v-layout>
				</v-layout>
			</v-layout>

			<!-- --- 데이터 테이블 -------- start -->
			<v-layout wrap>
				<!-- 테이블 -->
				<v-flex xs12>
					<datatable :datatable="table.datatable" class="tbl-type01" :detailClick="detailClick" @pagination="pagination"> </datatable>
				</v-flex>
			</v-layout>
			<!-- --- 데이터 테이블 -------- end -->
		</div>

		<!-- 캠페인 현황 관리 다이어로그 -->
		<editMarketingCircumstance :updateCampaginList="updateList" :setdialog="detail_dialog" />

		<!-- 고객데이터 삭제 팝엄 -->
		<sweetAlert :dialog="sweetDialog" @click="delete_active()" />
		<sweetAlert :dialog="sweetDone" />
	</div>
</template>

<script>
import { editMarketingCircumstance, datatable, selectBox, sweetAlert, txtField } from '@/components/index.js'
export default {
	components: {
		editMarketingCircumstance,
		datatable,
		selectBox,
		txtField,
		sweetAlert,
	},
	props: {
		nowTabs: Number,
		tabIdx: Number,
	},
	// watch: {
	// 	nowTabs: {
	// 		deep: true,
	// 		async handler() {
	// 			if (this.nowTabs === this.tabIdx) {
	// 				this.updateList()
	// 			}
	// 		},
	// 	},
	// },
	data() {
		return {
			businessId: '',
			// --- 데이터 테이블 데이터 --``
			surveySel_project: {
				value: '',
				errorMessage: '',
				hideDetail: true,
				items: [],
				fullItem: [],
				outlined: true,
				filter: true,
				label: '',
				returnObject: true,
				itemText: 'title',
			},
			table: {
				datatable: {
					headers: [
						{ text: 'No.', value: 'pj_no', width: '5%' },
						{ text: '프로젝트 명', value: 'business_title', width: '15%', sortable: false },
						{ text: '캠페인', value: 'cpnTitle', width: '15%' },
						{ text: '활용DB', value: 'dbTitle', width: '15%' },
						{ text: '등록일', value: 'cpnCreated', width: '9%' },
						{ text: '시작일', value: 'cpnStart', width: '9%' },
						{ text: '종료일', value: 'cpnEnd', width: '9%' },
						{ text: '적용DB수량', value: 'cpnDistribution', width: '9.5%' },
						{ text: '처리', value: 'cpnProc', width: '9.5%' },
						{ text: '미처리', value: 'cpnUnproc', width: '9.5%' },
						{
							text: '비고',
							align: 'center',
							value: 'etc_detail',
							width: '9.5%',
						},
					],
					items: [
						// {
						// 	pj_no: '0',
						// 	cpnId: '1',
						// 	cpnTitle: '프로젝트테스트1',
						// 	dbTitle: '테스트 자이1차',
						// 	cpnCreated: '2024-05-17',
						// 	cpnStart: '2024-04-17',
						// 	cpnEnd: '2024-05-17',
						// 	dbTotal: '1500',
						// 	cpnDistribution: '800',
						// 	dbLeft: '700',
						// },
					],
					hidedefaultfooter: false,
					noweditting: '',
					// title: x.name,
					onlyAgree: false,
					// inputboxId: x.id,
					total: 0,
					itemPerPage: 10,
					page: 1,
					pageCount: 0,
				},
				filter: [],
				json_fields: {},
			},

			// 날짜/검색 데이터
			filterDate: {
				value: '오늘',
				errorMessage: '',
				hideDetail: true,
				items: ['오늘', '이번 주', '이번 달'],
				outlined: true,
			},

			filterTag: {
				value: '전체',
				errorMessage: '',
				hideDetail: true,
				items: ['전체', '제목', '이름'],
				outlined: true,
			},

			searchsel_type: {
				value: '이름',
				errorMessage: '',
				hideDetail: true,
				items: ['전체', '이름', '연락처'],
				outlined: true,
			},
			search: {
				placeholder: '검색어를 입력해주세요.',
				maxlength: '255',
				outlined: true,
				backCol: 'white',
				value: '',
			},

			termStartpicker: {
				// datePicker
				date: this.$moment().format('YYYY-MM-DD'),
				errorMessage: '',
				class: 'whiteBack defalut-date-picker-setting',
				menu: false,
			},

			termEndpicker: {
				// datePicker
				date: this.$moment().format('YYYY-MM-DD'),
				errorMessage: '',
				class: 'whiteBack defalut-date-picker-setting',
				menu: false,
			},

			addBtn: {
				// 추가 버튼
				dark: true,
				width: 100,
			},

			reservedaysData: {},
			sweetDone: {
				//  삭제 완료
				open: false,
				title: '고객 정보 삭제 완료',
				content: `고객 정보를 삭제하였습니다.`,
				modalIcon: 'success',
				cancelBtnText: '확인',
				buttonType: 'oneBtn',
			},
			sweetDialog: {
				// 삭제 확인 팝업
				open: false,
				title: '고객 정보 삭제',
				content: `선택한 고객 정보를 삭제하시겠습니까?`,
				cancelBtnText: '취소',
				saveBtnText: '삭제',
				buttonType: 'twoBtn',
				modalIcon: 'info',
				item: {},
			},

			detail_dialog: {
				title: '',
				dialog: false,
				id: '',
			},
		}
	},
	async created() {
		await this.reservedays()
		// await this.getTableData()
	},
	computed: {},
	methods: {
		updateList() {
			this.getTableData(this.table.datatable)
		},
		/**캠페인 데이터랑 마케팅 데이터를 묶어서 데이터로 가져옴 페이지네이션을 위해서 
		 * range오브젝트를 따로 가져옴 베이스 데이터로는 table.pagination을 참조
@param {object} range 범위를 체크하는 오브젝트
@author 노의진
*/
		async getTableData(range) {
			this.$store.state.loading = true
			let form = {
				start: range ? (range.page - 1) * range.itemPerPage : 0,
				limit: range ? range.itemPerPage : 10,
			}

			if (this.surveySel_project.value.id !== 'all') {
				form['businessId'] = [this.surveySel_project.value.id]
			} else {
				form['businessId'] = this.surveySel_project.items.map(el => String(el.id))
			}
			if (this.$gf.checkBlank(this.search.value)) {
				form['campaignTitle'] = this.search.value
			}

			await this.$store.dispatch('getMarketingCampaigns', form).then(res => {
				this.$store.state.loading = false
				const data = res.data.getCampaigns.response

				if (Array.isArray(data.campaigns) && data.campaigns.length > 0) {
					for (let i = 0; i < data.campaigns.length; i++) {
						data.campaigns[i]['pj_no'] = i + 1 + (this.table.datatable.pagination.page - 1) * this.table.datatable.pagination.itemsPerPage
						// data.campaigns[i]['dbLeft'] = data.campaigns[i].dbTotal - data.campaigns[i].cpnDistribution
						const marketing_business = this.surveySel_project.items.filter(el => String(el.id) === String(data.campaigns[i].businessId))
						if (marketing_business.length > 0) {
							data.campaigns[i]['business_title'] = marketing_business[0].title
						}
					}
				}
				this.table.datatable.items = data.campaigns
				this.table.datatable.total = data.total
			})

			// 검색 텍스트필드 blur 처리
			this.$refs.search_input.$children[0].$refs.input.blur()
		},
		/**캠페인데이터에서 서칭 필터를 걸때는 강제로 페이지를 1로 이동시킨후 작업해줌
	@author 노의진
	*/
		async searchKeyword() {
			this.table.datatable.page = 1
			await this.getTableData()
		},

		async search_reservedays() {
			this.table.datatable.page = 1
			this.search.value = ''
			await this.getTableData()
		},
		maskingName(strName) {
			if (strName.length > 2) {
				var originName = strName.split('')
				originName.forEach((name, i) => {
					if (i === 0 || i === originName.length - 1) return
					originName[i] = '*'
				})
				var joinName = originName.join()
				return joinName.replace(/,/g, '')
			} else {
				var pattern = /.$/ // 정규식
				return strName.replace(pattern, '*')
			}
		},
		maskingPhoneNumber(phoneNumber) {
			const values = phoneNumber.split('-')
			if (values.length > 1) {
				values[1] = '*'.repeat(values[1].length - 2) + values[1][values[1].length - 2] + values[1][values[1].length - 1]
			}
			if (values.length > 2) {
				values[2] = '*'.repeat(values[2].length - 2) + values[2][values[1].length - 2] + values[2][values[1].length - 1]
			}
			return values.join('-')
		},

		async reservedays() {
			this.$store.state.loading = true
			await this.$store.dispatch('bizTitle').then(async resData => {
				if (resData.data.bizTitle.businesses.length > 0) {
					resData.data.bizTitle.businesses.unshift({
						code: 'all',
						id: 'all',
						phone: '',
						title: '전체',
					})
					this.surveySel_project.items = resData.data.bizTitle.businesses
					this.surveySel_project.value = resData.data.bizTitle.businesses[0]
					this.businessId = resData.data.bizTitle.businesses[0].id
					this.$store.state.loading = false
				} else {
					this.$store.state.loading = false
				}
			})
		},

		// 셀렉트 박스 선택된 값 테이블 적용
		async setdate() {
			let today = new Date()
			let before = new Date(today.setDate(today.getDate() - 7))
			let after = new Date(today.setDate(today.getDate() + 7))
			this.termStartpicker.date = this.$moment(before).format('YYYY-MM-DD')
			this.termEndpicker.date = this.$moment(after).format('YYYY-MM-DD')
		},

		termCustomer(val) {
			let start = this.$moment(this.termStartpicker.date).format('YYMMDD')
			let startDate = new Date(this.termStartpicker.date)
			let end = new Date(startDate.setDate(startDate.getDate() + 240))
			let endDate = this.$moment(end).format('YYMMDD')
			val = this.$moment(val).format('YYMMDD') < endDate && this.$moment(val).format('YYMMDD') >= start
			return val
		},
		selectDays() {
			let date
			if (this.$moment().format('ddd') === 'Sun') {
				date = 6
			} else if (this.$moment().format('ddd') === 'Mon') {
				date = 0
			} else if (this.$moment().format('ddd') === 'Tue') {
				date = 1
			} else if (this.$moment().format('ddd') === 'Wed') {
				date = 2
			} else if (this.$moment().format('ddd') === 'Thu') {
				date = 3
			} else if (this.$moment().format('ddd') === 'Fri') {
				date = 4
			} else if (this.$moment().format('ddd') === 'Sat') {
				date = 5
			}
			if (this.filterDate.value === '오늘') {
				this.termEndpicker.date = this.$moment().format('YYYY-MM-DD')
				this.termStartpicker.date = this.$moment().format('YYYY-MM-DD')
			} else if (this.filterDate.value === '어제') {
				this.termStartpicker.date = this.$moment()
					.subtract(1, 'days')
					.format('YYYY-MM-DD')
				this.termEndpicker.date = this.$moment().format('YYYY-MM-DD')
			} else if (this.filterDate.value === '이번 주') {
				this.termStartpicker.date = this.$moment()
					.subtract(date, 'day')
					.format('YYYY-MM-DD')
				this.termEndpicker.date = this.$moment().format('YYYY-MM-DD')
			} else if (this.filterDate.value === '지난 주') {
				this.termStartpicker.date = this.$moment()
					.subtract(date + 7, 'day')
					.format('YYYY-MM-DD')
				this.termEndpicker.date = this.$moment()
					.subtract(date + 1, 'day')
					.format('YYYY-MM-DD')
			} else if (this.filterDate.value === '최근 7일') {
				this.termStartpicker.date = this.$moment()
					.subtract(7, 'days')
					.format('YYYY-MM-DD')
				this.termEndpicker.date = this.$moment().format('YYYY-MM-DD')
			} else if (this.filterDate.value === '최근 14일') {
				this.termStartpicker.date = this.$moment()
					.subtract(14, 'days')
					.format('YYYY-MM-DD')
				this.termEndpicker.date = this.$moment().format('YYYY-MM-DD')
			} else if (this.filterDate.value === '최근 30일') {
				this.termStartpicker.date = this.$moment()
					.subtract(30, 'days')
					.format('YYYY-MM-DD')
				this.termEndpicker.date = this.$moment().format('YYYY-MM-DD')
			} else if (this.filterDate.value === '이번 달') {
				this.termStartpicker.date = this.$moment()
					.subtract(Number(this.$moment().format('DD')) - 1, 'days')
					.format('YYYY-MM-DD')
				this.termEndpicker.date = this.$moment().format('YYYY-MM-DD')
			} else if (this.filterDate.value === '지난 달') {
				this.termStartpicker.date = this.$moment()
					.subtract(1, 'm')
					.startOf('month')
					.format('YYYY-MM-DD')
				this.termEndpicker.date = this.$moment()
					.subtract(1, 'm')
					.endOf('month')
					.format('YYYY-MM-DD')
			} else if (this.filterDate.value === '전체') {
				this.termStartpicker.date = ''
				this.termEndpicker.date = ''
			}
		},

		detailClick(item) {
			// 데이터 테이블 - 자세히보기 클릭
			this.detail_dialog.dialog = true
			this.detail_dialog.id = item.cpnId
		},

		async pagination(item) {
			if (!this.table.datatable.pagination) {
				this.table.datatable['pagination'] = item
				this.table.datatable.options = item
			}
			if (item.itemsPerPage === -1) item.itemsPerPage = this.table.datatable.total
			if (item.page > this.table.datatable.pagination.page) {
				// 다음 페이지
				let range = {
					start: (item.page - 1) * item.itemsPerPage,
					limit: item.itemsPerPage,
					itemPerPage: item.itemsPerPage,
					page: item.page,
				}
				this.getTableData(range)
			} else if (item.itemsPerPage !== this.table.datatable.pagination.itemsPerPage) {
				// 한페이지에 보여줄 아이템 개수 변경
				let range = {
					start: 0,
					limit: item.itemsPerPage,
					itemPerPage: item.itemsPerPage,
					page: 1,
				}
				this.getTableData(range)
			} else if (item.page < this.table.datatable.pagination.page) {
				// 이전 페이지
				let range = {
					start: (item.page - 1) * item.itemsPerPage,
					limit: item.itemsPerPage,
					itemPerPage: item.itemsPerPage,
					page: item.page,
				}
				this.getTableData(range)
			}
			this.table.datatable['pagination'] = { ...item }
		},
		async delete_active() {
			this.sweetDialog.open = false
			this.$store.state.loading = true
		},
	},
}
</script>
<style lang="scss" scoped>
.wrapper {
	margin: 0px !important;
}
</style>
<style lang="scss">
.surveyChoice {
	font-size: 18px;
	font-weight: bold;
	margin-right: 10px;
}

.surveyTitle {
	font-size: 18px;
	font-weight: bold;
	margin-top: 20px;
}

.filterFlex {
	padding: 20px 20px 58px 0px;
}

.filterBox {
	background: white;
	height: 100%;
	border: 2px solid #e1e1e1;
	border-radius: 5px;
}

.filterHead {
	margin: 0px !important;
	padding: 14px;
	border-bottom: 1.5px solid #e1e1e1;
}

.filterLayout {
	padding: 14.8px;
	// border-bottom: 1.5px solid #e1e1e1;`
}

.checkboxLinebreak {
	line-break: anywhere;
}

.qaLists-dialog {
	opacity: 0;
	width: 100%;
	background-color: white !important;
}

.search_box_type {
	width: auto !important;
	height: 26px !important;
	margin-right: 10px !important;
	padding: 0 10px !important;
	font-size: 13px;
	font-weight: bold;

	.v-btn__content {
		color: #fff;
	}
}

//검색 박스
.search_box_type {
	width: 193px;
	margin-left: 10px;

	div {
		div {
			.v-input__slot {
				min-height: 26px !important;
				height: 26px;
				padding: 0 10px !important;
			}
		}
	}
}

.search_select_type {
	min-height: 26px !important;
	height: 26px !important;
	width: 400px;
	max-width: 400px;

	div {
		div {
			div {
				div {
					.v-input__append-inner {
						margin-top: 1px !important;
					}
				}
			}
		}
	}
}

.customer-management-text {
	font-size: 12px;
	font-weight: bold;
	width: auto;
	color: #204037;
}

.customer-management-btn {
	box-shadow: none;
	border: 1px solid #c5c3d5;
	width: 88px;
	height: 26px !important;
	background-color: #f3f3ff !important;

	.v-btn__content {
		color: #323153;
		font-size: 13px;
	}
}
</style>
